var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-ing"},[_c('div',{staticClass:"live-ing-txt"},[_vm._v("主播暂未开播")])])
}]

export { render, staticRenderFns }